module.exports = __webpack_public_path__ + "static/media/correct_otm_sample_image.eab17f64.svg";